export default __webpack_public_path__ + "static/media/logo-salesforce.c849d2cc.png";